import axios from 'axios'
import router from '../../router'
axios.defaults.withCredentials = true;

const login = {
    state: {
        user: {
            role: {}
        },
        statusAuth: false
    },
    actions: {
        async A_LOGIN ({ commit }, payload) {
            try {
                await axios.get('/sanctum/csrf-cookie')
                const login = await axios.post( '/api/auth/login',  payload)
                await commit('M_LOGIN', login)
                return true
            } catch (e) {
                console.error(e)
                return false
            }
        },


        async A_ME ({ commit }) {
            try {
                    await axios.get('/sanctum/csrf-cookie')
                    const login = await axios.get( '/api/auth/me')
                    await commit('M_LOGIN', login)
            } catch (e) {
                    console.error(e)
            }
        },

        async A_LOGOUT ({ commit }) {
            await axios.get('/sanctum/csrf-cookie');
            await axios.get( '/api/auth/logout');
            await commit('M_LOGOUT')
            await router.push('/auth/login');
        }



    },
    mutations: {
        M_LOGIN(state, user) {
            state.user = user.data.user
            state.statusAuth = user.data.auth
        },

        M_LOGOUT(state) {
            state.user = {};
            state.statusAuth = false;
        }
    },
    getters: {
        GET_IS_LOGGET: state => { return state.statusAuth },
        GET_USER_NAME: state => { return state.user.name + ' ' + state.user.lastname },
        GET_USER_EMAIL: state => { return state.user.email },
        GET_USER_ROLE: state => { return state.user.role.role ?? '' },
        IS_SUPER_ADMIN: state => { return state.user.role.slug === 'super-admin' }

    }
}

export default login
